module.exports = __webpack_public_path__ + "img/exclamatory_mark.2d78b68f.png";